import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BlogpostsComponent } from './components/blogposts/blogposts.component';
import { BlogpostComponent } from './components/blogpost/blogpost.component';
import { BlogpostsRoutingModule } from './blogposts.routing.module';



@NgModule({
  declarations: [BlogpostComponent, BlogpostsComponent],
  imports: [
    CommonModule,
    BlogpostsRoutingModule
  ]
})
export class BlogpostsModule { }
